<template>
    <div>
        <template v-if="loading">
            Loading <i class="fa fa-spinner fa-spin"></i>
        </template>
        <template v-else>
            <vue-headful :title="'[Delete Contact] ' + contact.first_name + ' '+contact.last_name+' - AMOS365'" />
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="`/${record_url}`">{{  (contact.record_type.charAt(0).toUpperCase() + contact.record_type.slice(1)) }}</router-link>
                    </li>
                    <li class="breadcrumb-item" v-if="contact.record_id && contact.record_name">
                        <router-link :to="`/${record_url}/view/${contact.record_id}`">{{ contact.record_name }}</router-link>
                    </li>                    
                    <li class="breadcrumb-item">Contact: {{ contact.first_name }} {{ contact.last_name }}</li>
                    <li class="breadcrumb-item active" aria-current="page">Delete</li>
                </ol>
            </nav>

            <h4 class="page-header">
                Delete: {{ contact.first_name }} {{ contact.last_name }}
            </h4>

            <div class="row mb-4">
                <div class="col-md-8 col-12">
                    <div class="card mb-4">
                        <div class="card-header">
                            <strong>Confirm:</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">
                                <strong>Warning:</strong> You are about to delete this contact. This is a permanent change and cannot be undone. All associated contact information will also be deleted.
                            </div>

                            <div class="mt-2">
                                {{ contact.first_name }} {{ contact.last_name }} 
                            </div>
                            <div class="text-muted" v-if="contact.title">{{ contact.title }}</div>
                            <ul class="list-unstyled mb-0" v-if="contact.emails">
                                <li v-for="email in contact.emails">
                                    <i class="fa fa-envelope"></i> <a :href="`mailto:${email.email}`">{{ email.email }}</a> <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="email.is_primary">Primary</label>
                                </li>
                            </ul>
                            <ul class="list-unstyled mb-0" v-if="contact.phones">
                                <li v-for="phone in contact.phones">
                                    <i class="fa fa-phone"></i> <a :href="`tel:${phone.phone}`">{{ phone.phone }}</a> <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="phone.is_primary">Primary</label>
                                </li>
                            </ul>
                            <ul class="list-unstyled mb-0" v-if="contact.addresses">
                                <li v-for="address in contact.addresses">
                                    <i class="fa fa-globe"></i>
                                    {{ address.address }} <br v-if="address.address && address.city" />
                                    {{ address.city }}, {{ address.state_id ? address.state.state_name : '' }} {{ address.zip }} <label class="badge badge-info" style="font-size: 85%; font-weight: 400;" v-if="address.is_primary">Primary</label>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <button type="button" 
                    class="btn btn-sm btn-danger" 
                    v-on:click="deleteContact()" 
                    :disabled="deleting">
                    <template v-if="deleting"><i class="fas fa-spin fa-spinner"></i> Deleting...</template>
                    <template v-else><i class="fas fa-save"></i> Delete</template>
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                deleting: false,
                id: this.$route.params.id,
                contact: {},
                errors: {},
            }
        },

        computed: {
            record_url(){
                //Check for Null
                if(!this.contact.record_type)
                {
                    return null;
                }

                //Helpers Based on the Record Type
                var key = this.contact.record_type.toLowerCase();
                var url = key + 's';

                //Handler
                switch(this.contact.record_type)
                {
                    //Customer Stuff
                    case 'Agency':
                        url = 'agencies';
                        break;
                }

                //SEnd it
                return url;
            }
        },

        methods: {

            getContact(){
                //Send it
                this.$http.get('/contacts/delete/' + this.id, this.$route.query)
                    .then(response => {
                        //Set the contact
                        this.contact = response.data.contact;
                    })
                    .catch(error => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },

            deleteContact(){
                //Helpers
                this.deleting = true;

                //Reset ERror
                this.errors = {};

                //Send it
                this.$http
                .post('contacts/delete/'+this.id)
                .then(response => {
                    //Alert the user?
                    this.$toastr.s('Contact Deleted');

                    //Return to main list?
                    this.$router.push('/'+this.record_url+'/view/' + this.contact.record_id);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to Delete Contact');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.deleting = false;
                });
            },
        },

        mounted() {
            //get the contact?
            this.getContact();
        }
    }
</script>
